import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { CareerPlan, CareerPlanSkill } from '../models/career-plans';
import { ScreenBreakpoint } from '../models/screen-width-breakpoints';

@Injectable({
  providedIn: 'root',
})
export class CareerPlansService {
  private skillUnrolled = new Subject<CareerPlanSkill>();

  constructor() {}

  getSkillUnrolledObs(): Observable<CareerPlanSkill> {
    return this.skillUnrolled.asObservable();
  }

  notifySkillUnrolled(skill: CareerPlanSkill) {
    this.skillUnrolled.next(skill);
  }

  updateSkillRows(bp: ScreenBreakpoint, careerPlan: CareerPlan, skillRows: CareerPlanSkill[][]) {
    if (careerPlan == null) {
      return;
    }

    skillRows = [];
    let maxSkillsPerRow;

    if (bp <= ScreenBreakpoint.LANDSCAPE_MOBILE) {
      maxSkillsPerRow = 1;
    } else if (bp < ScreenBreakpoint.LARGER_DESKTOP) {
      maxSkillsPerRow = 2;
    } else {
      maxSkillsPerRow = 3;
    }

    let currentRow = [];
    careerPlan.skills.forEach((skill) => {
      currentRow.push(skill);

      if (currentRow.length == maxSkillsPerRow) {
        skillRows.push(currentRow);
        currentRow = [];
      }
    });

    if (currentRow.length > 0 && currentRow.length < maxSkillsPerRow) {
      skillRows.push(currentRow);
    }

    return skillRows;
  }
}
